module.exports = __webpack_public_path__ + "img/อ่านไม่เข้าใจ_ คลิกตรงนี้.a6b6f06c.svg";